import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinGame from '@/mixins/game'
import { moleculeTypes } from '@/constants/molecule'

@Component
export default class Turn extends mixins(MixinGame) {
  public endTurn() {
    this.checkPawnsOnBreakMolecules()
    this.increaseTurnID()
  }

  public checkPawnsOnBreakMolecules() {
    this.pawns.forEach((pawn) => {
      const molecule = this.$molecules.find(pawn.moleculeID)

      if (molecule.type === moleculeTypes.REGULAR) {
        this.updatePawn({
          id: pawn.id,
          attributes: [
            {
              key: 'teamID',
              value: null,
            },
            {
              key: 'playerID',
              value: null,
            },
          ],
        })
      }
    })
  }
}
